import { render, staticRenderFns } from "./InvoicingProviderSettings.yaml?vue&type=template&id=1dbec36b&component"
import script from "./InvoicingProviderSettings.yaml?vue&type=script&lang=ts&component"
export * from "./InvoicingProviderSettings.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports